import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContextState } from './context.state';


export const selectContextState = createFeatureSelector<ContextState>('context');
export const selectPolicyId = createSelector(selectContextState, (state: ContextState) => state.policyId);